// extracted by mini-css-extract-plugin
export default {"wrap":"QG-z","fullWidth":"RG-z","hideOnDesktop":"SG-z","content":"TG-z","hasOpenedNav":"UG-z","crumbsList":"VG-z","dropdownsWrap":"WG-z"};